import { render } from "./design-approve-process.vue?vue&type=template&id=cd1429fe&scoped=true"
import script from "./design-approve-process.vue?vue&type=script&lang=js"
export * from "./design-approve-process.vue?vue&type=script&lang=js"

import "./design-approve-process.vue?vue&type=style&index=0&id=cd1429fe&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd1429fe"]])

export default __exports__